(() => {
  if (window.flowBrosPackPricing) return;
  window.flowBrosPackPricing = true;
  const attached = new WeakSet();
  const text = (node, value) => {
    if (node && node.textContent !== value) node.textContent = value;
  };
  function attach() {
    document.querySelectorAll('.product-details kaching-bundles-block').forEach(bundle => {
      if (attached.has(bundle)) return;
      attached.add(bundle);
      const details = bundle.closest('.product-details');
      const section = details.closest('.shopify-section');
      const update = () => {
        if (details.querySelector('[data-deal-bar-id="o278"], [data-deal-bar-id="6Sft"]')) {
          details.querySelectorAll('.sls-more-info-container').forEach(container => {
            if (container.querySelector('.flow-bros-cancel-anytime')) return;
            const note = document.createElement('span');
            note.className = 'flow-bros-cancel-anytime';
            note.textContent = 'Cancel anytime';
            container.append(note);
          });
        }
        bundle.querySelectorAll(':is([data-deal-bar-id="o278"], [data-deal-bar-id="5d969ccb-7832-4955-ac26-4588fc59999e"], [data-deal-bar-id="6Sft"]) .kaching-bundles__bar-title').forEach(node => text(node, 'Single'));
        if (typeof bundle.pricing !== 'function') return;
        const pricing = bundle.pricing();
        if (!pricing?.discountedPrice?.formatted) return;
        const oneTime = pricing.discountedPriceWithoutSellingPlan || pricing.discountedPrice;
        const plans = pricing.discountedPricesForSellingPlans || [];
        const selectedPlan = Number(details.querySelector('[name="selling_plan"]')?.value);
        const subscribed = !!details.querySelector('.sls-option[data-type="subscription"]:checked');
        const planPrice = plans.find(plan => plan.sellingPlanId === selectedPlan);
        const planAttribute = subscribed && planPrice ? String(selectedPlan) : '';
        if ((bundle.getAttribute('selling-plan-id') || '') !== planAttribute) {
          bundle.setAttribute('selling-plan-id', planAttribute);
        }
        const clean = price => price.formatted.replace(/<[^>]*>/g, '');
        const total = clean(subscribed && planPrice ? planPrice : oneTime);
        details.dataset.packTotal = total;
        details.querySelectorAll('product-price .price').forEach(node => text(node, total));
        details.querySelectorAll('.add-to-cart-button').forEach(button => {
          let price = button.querySelector('.flow-bros-button-total');
          if (!price) {
            price = document.createElement('span');
            price.className = 'flow-bros-button-total';
            button.querySelector('.add-to-cart-text')?.append(price);
          }
          text(price, ` — ${total}`);
        });
        details.querySelectorAll('.sealsubs-container').forEach(widget => {
          widget.hidden = !plans.length;
          if (!plans.length) {
            const oneTimeOption = widget.querySelector('.sls-option[data-type="one_time"]');
            if (oneTimeOption && !oneTimeOption.checked) oneTimeOption.click();
            return;
          }
          text(widget.querySelector('.sls-one-time-price .money'), clean(oneTime));
          const interval = Number(widget.querySelector('[name="subs_interval"]')?.value);
          const subscriptionPrice = plans.find(plan => plan.sellingPlanId === interval) || plans[0];
          text(widget.querySelector('.sls-selling-plan-group-price .money'), clean(subscriptionPrice));
          const saving = oneTime.amount > 0 ? Math.round((1 - subscriptionPrice.amount / oneTime.amount) * 100) : 0;
          text(widget.querySelector('.sls-savings-badge'), `SAVE ${saving}%`);
        });
      };
      bundle.addEventListener('items-changed', update);
      details.addEventListener('change', () => requestAnimationFrame(update));
      new MutationObserver(() => requestAnimationFrame(update)).observe(details, {childList: true, subtree: true});
      update();
    });
  }
  document.addEventListener('DOMContentLoaded', attach);
  window.addEventListener('kaching-bundles-initialized', attach);
  new MutationObserver(attach).observe(document.documentElement, {childList: true, subtree: true});
  attach();
})();
